import { Company } from './company';
import { Funder } from './funder';
import { SchemeGroup } from './scheme-group';
import { User } from './user';


export class Scheme {
  scheme_code!: string;
  scheme_name!: string;
  scheme_description!: string;
  scheme_group_number?: string;
  status!: string;
  scheme_type!: string;
  sponsor_required!: boolean;
  excerpt!: string;
  global_limit!: number;
  suspension_grace_period!: number;
  termination_grace_period!: number;
  corporate_member_rate!: number;
  corporate_spouse_rate!: number;
  corporate_child_rate!: number;
  corporate_dependent_rate!: number;
  individual_member_rate!: number;
  individual_spouse_rate!: number;
  individual_child_rate!: number;
  individual_dependent_rate!: number;
  individual_annual_member_rate!: number;
  individual_annual_spouse_rate!: number;
  individual_annual_child_rate!: number;
  individual_annual_dependent_rate!: number;
  corporate_age_limit!: number;
  individual_age_limit!: number;
  individual_member_waiting_period_length!: number;
  individual_spouse_waiting_period_length!: number;
  individual_child_waiting_period_length!: number;
  individual_dependent_waiting_period_length!: number;
  corporate_member_waiting_period_length!: number;
  corporate_spouse_waiting_period_length!: number;
  corporate_child_waiting_period_length!: number;
  corporate_dependent_waiting_period_length!: number;
  corporate_members_can_submit_claims!: boolean;
  individual_members_can_submit_claims!: boolean;
  commission_applicable!: boolean;
  currency!: string;
  scheme_image_path?: string;
  scheme_brochure_path?: string;
  date_deleted?: number;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  company_schemes?: Array<CompanyScheme>;

  scheme_group?: SchemeGroup;

  isSpecial() {
    return this.scheme_type.toLowerCase() == 'special';
  }

  constructor(data: any) {
    this.scheme_code = data.scheme_code;
    this.scheme_name = data.scheme_name;
    this.scheme_description = data.scheme_description;
    this.scheme_group_number = data.scheme_group_number;
    this.status = data.status;
    this.scheme_type = data.scheme_type;
    this.sponsor_required = data.sponsor_required;
    this.excerpt = data.excerpt;
    this.global_limit = data.global_limit;
    this.suspension_grace_period = data.suspension_grace_period;
    this.termination_grace_period = data.termination_grace_period;
    this.corporate_member_rate = data.corporate_member_rate;
    this.corporate_spouse_rate = data.corporate_spouse_rate;
    this.corporate_child_rate = data.corporate_child_rate;
    this.corporate_dependent_rate = data.corporate_dependent_rate;
    this.individual_member_rate = data.individual_member_rate;
    this.individual_spouse_rate = data.individual_spouse_rate;
    this.individual_child_rate = data.individual_child_rate;
    this.individual_dependent_rate = data.individual_dependent_rate;
    this.individual_annual_member_rate = data.individual_annual_member_rate;
    this.individual_annual_spouse_rate = data.individual_annual_spouse_rate;
    this.individual_annual_child_rate = data.individual_annual_child_rate;
    this.individual_annual_dependent_rate = data.individual_annual_dependent_rate;
    this.corporate_age_limit = data.corporate_age_limit;
    this.individual_age_limit = data.individual_age_limit;
    this.individual_member_waiting_period_length = data.individual_member_waiting_period_length;
    this.individual_spouse_waiting_period_length = data.individual_spouse_waiting_period_length;
    this.individual_child_waiting_period_length = data.individual_child_waiting_period_length;
    this.individual_dependent_waiting_period_length = data.individual_dependent_waiting_period_length;
    this.corporate_members_can_submit_claims = data.corporate_members_can_submit_claims;
    this.corporate_member_waiting_period_length = data.corporate_member_waiting_period_length;
    this.corporate_spouse_waiting_period_length = data.corporate_spouse_waiting_period_length;
    this.corporate_child_waiting_period_length = data.corporate_child_waiting_period_length;
    this.corporate_dependent_waiting_period_length = data.corporate_dependent_waiting_period_length;
    this.individual_members_can_submit_claims = data.individual_members_can_submit_claims;
    this.commission_applicable = data.commission_applicable;
    this.currency = data.currency;
    this.scheme_image_path = data.scheme_image_path;
    this.scheme_brochure_path = data.scheme_brochure_path;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.company_schemes) {
      this.company_schemes = data.company_schemes.map((el: any) => new CompanyScheme(el));
    }
    if (data.scheme_group) {
      this.scheme_group = new SchemeGroup(data.scheme_group);
    }
  }
}


export class CompanyScheme {
  scheme_code: string;
  company_number: string;
  company: Company;
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;

  constructor(data: any) {
    this.scheme_code = data.scheme_code;
    this.company_number = data.company_number;
    this.company = data.company;
    this.uuid = data.uuid;
    this.user_uuid = data.user_uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
  }
}
